import axios from "axios";
import isNull from "../../mixin/isNull";

export default function () {
    const buildParam = (params, perPage, orderBy, sortBy, currentPage) => {
        let queryStrings = [];

        if (!isNull(params) && params.length > 0) {
            for (let i = 0; i < params.length; i++) {
                queryStrings.push(params[i].replace("[", encodeURIComponent("[")).replace("]", encodeURIComponent("]")));
            }
        }

        queryStrings.push(`per_page=${perPage}`);
        queryStrings.push(`page=${currentPage}`);

        if (!isNull(orderBy)) {
            queryStrings.push(`orderBy=${orderBy}`);
        }

        if (!isNull(sortBy)) {
            queryStrings.push(`sortBy=${sortBy}`);
        }

        let result = "?";

        for (let i = 0; i < queryStrings.length; i++) {
            result += queryStrings[i] + (i < queryStrings.length ? "&" : "");
        }

        return result;
    }


    return {
        findAllStandardizedItem: async (workId, prescriberId) => {
            const result = [];
            let currentPage = 1;
            let lastPage = 50;
            const queryString = [];
            const perPage = 200;


            queryString.push(`standardized_item_work_id[eq]=${workId}`);
            queryString.push(`standardized_item_prescriber_id[eq]=${prescriberId}`);

            while (currentPage <= lastPage) {
                try {
                    const response = await axios.get(process.env.REACT_APP_API_URL + "/service-data-repository/artisan/pagination/emergency/compiled_standardized_item" + buildParam(queryString, perPage, "DESC", "relaunch_id", currentPage))

                    lastPage = response.data.last_page;

                    for (let i = 0; i < response.data.data.length; i++) {
                        result.push(response.data.data[i]);
                    }

                    currentPage++;
                } catch (e) {
                    return null;
                }
            }

            return result;
        }
    }
}